import { render, staticRenderFns } from "./CAxASXxSexualPage.vue?vue&type=template&id=4c772dbc"
import script from "./CAxASXxSexualPage.vue?vue&type=script&lang=js"
export * from "./CAxASXxSexualPage.vue?vue&type=script&lang=js"
import style0 from "./CAxASXxSexualPage.vue?vue&type=style&index=0&id=4c772dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports